<template>
  <el-form ref="form" :model="curInput" :rules="rules" label-width="100px" v-loading="loading">
    <el-form-item label="仅允许一个部门">
      <el-radio-group v-model="curInput.struct.select_type">
        <el-radio :label="10">是</el-radio>
        <el-radio :label="20">否</el-radio>
      </el-radio-group>
      <el-button v-show="hasData" class="m-l-30" size="small" @click="getStruct">获取部门数据</el-button>
    </el-form-item>
    <el-form-item label="允许选择范围">
      <el-radio-group v-model="curInput.struct.select_range">
        <el-radio :label="10">不限</el-radio>
        <el-radio :label="20">用户所属部门</el-radio>
        <el-radio :label="30">自定义</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="选择范围" v-show="rangeShow">
      <el-select v-model="selectedStructId" multiple :disabled="hasData" :placeholder="selectPlaceholder" @change="selectRange()">
        <el-option
          v-for="item in structData"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="默认选中值">
      <el-radio-group v-model="curInput.struct.select_default">
        <el-radio :label="10">无</el-radio>
        <el-radio :label="20">用户所属部门</el-radio>
        <el-radio :label="30" v-show="isOwner">自定义</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="默认部门" v-show="showSingleDefault && isOwner">
      <el-select v-model="defaultStruct" :disabled="hasData" :placeholder="selectPlaceholder" @change="selectStruct()">
        <el-option
          v-for="item in selectedStruct"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="默认部门" v-show="showMultiDefault">
      <el-select v-model="defaultMultiStruct" multiple :disabled="hasData" :placeholder="selectPlaceholder" @change="selectMultiStruct()">
        <el-option
          v-for="item in selectedStruct"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item>
      <el-button type="primary" @click="onSubmit">log data</el-button>
    </el-form-item> -->
  </el-form>
</template>

<script>
  import http from '../../../assets/js/http'

  export default {
    props: ['curInput'],
    data() {
      return {
        mode: null,                 // 页面当前状态，'add'为添加，'edit'为编辑
        loading: false,
        hasData: false,
        selectPlaceholder: '请选择',
        defaultChangeTime: 0,
        defaultStruct: null,        // 单选情况下，已选中的默认部门的id
        selectedStruct: [],         // 选择范围已选择的值
        defaultMultiStruct: [],     // 多选情况下，已选中的默认部门的id集合
        selectedStructId: [],       // 选择范围已选中的值的id集合
        structData: []              // 部门数据
      }
    },
    methods: {
      onSubmit() {
        console.log('struct_option = ', _g.j2s(this.curInput))
      },
      selectRange() {
        // 每次选择范围时都需要清空数据
        this.resetStructOption()
        let arr = []
        let temp = {}
        this.selectedStruct = []
        _(this.selectedStructId).forEach((res) => {
          _(this.structData).forEach((res1) => {
            if (res == res1.id) {
              this.selectedStruct.push(res1)
              temp.struct_id = res
              temp.is_selected = 0
              arr.push(temp)
              temp = {}
            }
          })
        })
        this.curInput.struct_option = arr
      },
      selectStruct() {
        if (this.curInput.struct.select_range != 30) {
          // 如果选择范围不是自定义，则默认选项只有备选选项
          let arr = []
          const temp = {
            struct_id: this.defaultStruct,
            is_selected: 1
          }
          arr.push(temp)
          this.curInput.struct_option = arr
        } else {
          // 如果选择范围是自定义且有已选项，则从已选项中设置默认选项
          _(this.curInput.struct_option).forEach((res) => {
            if (res.struct_id == this.defaultStruct) {
              res.is_selected = 1
            }
          })
        }
      },
      selectMultiStruct() {
        if (this.curInput.struct.select_range != 30) {
          // 如果选择范围不是自定义，则默认选项为多选select回调的所有id
          let arr = []
          let temp = {}
          _(this.defaultMultiStruct).forEach((res) => {
            temp.struct_id = res
            temp.is_selected = 1
            arr.push(temp)
            temp = {}
          })
          this.curInput.struct_option = arr
        } else {
          // 如果选择范围是自定义且有已选项，则从已选项中设置默认选项
          _(this.curInput.struct_option).forEach((res) => {
            res.is_selected = 0
            _(this.defaultMultiStruct).forEach((res1) => {
              if (res.struct_id == res1) {
                res.is_selected = 1
              }
            })
          })
        }
      },
      resetDefaultStruct() {
        _(this.curInput.struct_option).forEach((res) => {
          res.is_selected = 0
        })
      },
      resetStructOption() {
        // 当选择范围不为自定义时，清空 curInput.struct_option
        if (this.curInput.struct.select_range != 30 && this.defaultChangeTime > 0) {
          this.curInput.struct_option = []
          this.defaultStruct = null
          this.defaultMultiStruct = []
        }
        this.defaultChangeTime++            // 用于区分初始化时编辑与添加
      },
      getStruct() {
        this.loading = !this.loading
        this.apiGet('admin/structures').then((res) => {
          this.loading = !this.loading
          if (res.code == 200) {
            this.selectPlaceholder = '请选择'
            this.hasData = false
            this.structData = res.data
            if (this.mode == 'add') {
              this.selectedStruct = this.structData
            } else {
              // 选择范围不限已选数据
              let selectDefault = _.cloneDeep(this.curInput.struct.select_default)
              if (this.curInput.struct.select_range == 10) {
                this.selectedStruct = this.structData
              } else if (this.curInput.struct.select_range == 30) {
                _(this.structData).forEach((res) => {
                  _(this.curInput.struct_option).forEach((res1) => {
                    if (res.id == res1.struct_id) {
                      this.selectedStructId.push(res.id)
                      this.selectedStruct.push(res)
                    }
                  })
                })
                setTimeout(() => {
                  this.curInput.struct.select_default = selectDefault
                }, 1000)
              }

              // 单选
              if (this.curInput.struct.select_type == 10) {
                _(this.curInput.struct_option).forEach((res) => {
                  if (res.is_selected) {
                    this.defaultStruct = res.struct_id
                  }
                })
              } else if (this.curInput.struct.select_type == 20) {
                let arr = []
                _(this.curInput.struct_option).forEach((res) => {
                  if (res.is_selected) {
                    arr.push(res.struct_id)
                  }
                })
                _(this.selectedStruct).forEach((res) => {
                  let index = _.indexOf(arr, res.id)
                  if (_.indexOf(arr, res.id) > -1) {
                    this.defaultMultiStruct.push(res.id)
                  }
                })
              }
            }
          } else {
            this.handleErr()
            _g.dealError(this, res)
          }
        }, (err) => {
          this.handleErr()
        })
      },
      handleErr() {
        this.loading = !this.loading
        this.hasData = true
        setTimeout(() => {
          this.selectPlaceholder = '获取部门数据失败'
        }, 100)
      }
    },
    computed: {
      rangeShow() {
        return this.curInput.struct.select_range == 30
      },
      showSingleDefault() {
        return this.curInput.struct.select_default == 30 && this.curInput.struct.select_type == 10
      },
      showMultiDefault() {
        return this.curInput.struct.select_default == 30 && this.curInput.struct.select_type != 10 && this.curInput.struct.select_range != 20
      },
      disableSingleDefault() {
        return this.selectedStruct.length
      },
      isOwner() {
        return this.curInput.struct.select_range != 20
      }
    },
    created() {
      // 判断当前状态是添加还是编辑
      if (!this.curInput.struct_option) {
        this.curInput.struct_option = []
      }
      if (!this.curInput.struct_option.length) {
        this.mode = 'add'
      } else {
        this.mode = 'edit'
      }
    },
    mounted() {
      this.getStruct()
    },
    watch: {
      'curInput.struct.select_type'() {
        this.resetStructOption()
      },
      'curInput.struct.select_range'() {
        this.resetStructOption()
        this.resetDefaultStruct()
        this.curInput.struct.select_default = 10
        this.selectedStructId = []
        if (this.curInput.struct.select_range == 10) {
          setTimeout(() => {
            this.selectedStruct = this.structData
            this.curInput.struct_option = []
          }, 0)
        } else if (this.curInput.struct.select_range == 20) {
          setTimeout(() => {
            this.curInput.struct_option = []
            this.selectedStruct = []
          }, 0)
        } else {
          this.curInput.struct_option = []
          this.selectedStruct = []
        }
      },
      'curInput.struct.select_default'() {
        // this.resetStructOption()
        if (this.curInput.struct.select_default == 10) {
          this.resetDefaultStruct()
        }
      },
      'curInput.struct.struct_option'() {
        if (!this.curInput.struct.struct_option) {
          this.curInput.struct.struct_option = []
        }
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// structConfig.vue?4b00b1b7